import { render, staticRenderFns } from "./linkage.vue?vue&type=template&id=16fd9596&scoped=true"
import script from "./linkage.vue?vue&type=script&lang=js"
export * from "./linkage.vue?vue&type=script&lang=js"
import style0 from "./linkage.vue?vue&type=style&index=0&id=16fd9596&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd9596",
  null
  
)

export default component.exports